import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';

@Component({
  selector: 'form-checkbox',
  styleUrls: ['form-checkbox.component.scss'],
  template: `
    <div 
      class="dynamic-field form-checkbox" 
      [ngClass]="{'required': required}" 
      [formGroup]="group">
      <label>{{ config.label }}</label>
      <input
        type="checkbox"
        [formControlName]="config.name">
    </div>
  `
})
export class FormCheckboxComponent implements OnInit, Field {
  config: FieldConfig;
  group: FormGroup;
  options: any;

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/dynamic-form/components/form-checkbox/form-checkbox.component.ts